export function setFiatOptions(fiats: any[], idProp: string) {
  return fiats
    ? fiats.map((fiat) => ({
      label: fiat[idProp],
      value: fiat[idProp],
    }))
    : [];
}
